<template>
    <div>
        <div class="contenedor" :class="{ 'desactivado': desactivar }">
            <h2 class="m-0 h1 text-uppercase">{{ $t('productos.title') }}</h2>
            <div class="subtitle h3 light mb-3 mb-lg-4">
                {{ $t('productos.subtitle') }}
                <span style="white-space: nowrap;" v-if="!url.includes('productos')">
                    <a style="color: var(--altcolor); border-bottom: 3px solid;" class="addProduct" @click.prevent="showModal('como-anadir-productos')">
                        {{ $t('productos.comoAnadirTitulo') }}
                    </a>
                </span>
            </div>
            <div class="dynamic-content">
                <div v-if="categories && filteredItems">
                    <TablaCategoriasComponent
                        :categories="categories"
                        :initial-category="selectedCategory"
                        :desactivar="desactivar"
                        @changeCategory="setCategory"
                    />
                    <MenuProductos
                        :menuItems="filteredItems"
                        :productos="productos"
                        :addToCart="addToCart"
                        :desactivar="desactivar"
                    />
                </div>
            </div>
        </div>
        <ComoAnadirProductos v-if="!url.includes('productos')" @close="closeModal" />
    </div>
</template>
  
<script>
import TablaCategoriasComponent from "./TablaCategoriasComponent.vue";
import MenuProductos from "./MenuProductosComponent.vue";
import ComoAnadirProductos from "../modals/ComoAnadirProductos.vue";
  
export default {
    props: {
        evento_id: {
            type: Number,
            required: false
        },
        desactivar: {
            type: Boolean,
            required: true,
        },
        productos: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            categories: [],
            selectedCategory: "",
            menuItems: [],
            isExpanded: false,
            loading: false,
        };
    },
    created() {
        this.getProductos();
    },
    computed: {
        filteredItems() {
            return this.menuItems.filter(
                item => item.category === this.selectedCategory
            );
        },
        configuracion() {
            return this.$store.getters.getConfig;
        },
        url() {
            return window.location.href;
        }
    },
    methods: {
        setCategory(category) {
            this.selectedCategory = category;
        },
        addToCart(product) {
            if (this.productos.find(item => item.item.id === product.item.id)) {
                this.productos.find(item => item.item.id === product.item.id).units += product.units;
            } else {
                this.productos.push(product);
            }
        },
        showModal(modal) {
            this.$modal.show(modal);
        },
        closeModal() {
            this.$modal.hide('como-anadir-productos');
        },
        getProductos() {
            const params = {
                filters: {
                    tid: this.configuracion.hash_teatro,
                },
                evento_id: this.$route.params.event_id ?? this.evento_id,
                sesion_id: this.$route.params.sesion_id,
            };

            this.$store.dispatch(this.config.getVuexAlias("front.events.sesion.productos"), params).then(res => {
                const productos = res.data.data;

                const allProducts = productos.flatMap(categoria => {
                    return categoria.products.map(product => ({
                        ...product,
                        category: categoria.name
                    }));
                });

                this.categories = productos.map(cat => cat.name);

                if (this.categories.length > 0) {
                    this.selectedCategory = this.categories[0];
                }

                this.menuItems = allProducts

            }).finally(() => {
                this.loading = false;
            });
        },
    },
    components: {
        TablaCategoriasComponent,
        MenuProductos,
        ComoAnadirProductos
    },
};
</script>
  

<style scoped>
    .no-style {
        padding-bottom: 0;
        position: relative; 
    }
    .desactivado {
        pointer-events: none; 
    }
    .addProduct {
        border-bottom: 3px solid;
        cursor: pointer;
    }
    .addProduct:hover {
        color: #FF6969 !important;
    }
    .dynamic-content {
        position: relative;
        min-height: 200px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .dynamic-content > div {
        width: 100%;
    }

    .dynamic-content LoaderComponent {
        margin: 0 auto;
    }
</style>